import 'popper.js';
import 'bootstrap';
import './swiper-init.js';

(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.helloWorld = {
    attach: function (context) {
      $("a", context).click(function (event) {
        if ($(this).attr('href').startsWith('#')) {
          $('html, body').animate({ scrollTop: $($(this).attr('href')).offset().top }, 500);
        }
      });
    }
  };

  $(".animate, .animate-wrapper svg").addClass('animate-out');
  animateElements();
  $(window).scroll(animateElements);

  function animateElements() {
    $(".animate, .animate-wrapper svg").each(function () {
      var top = $(this).position().top;
      var trigger = $(window).scrollTop() + $(window).height() * 0.9;
      $(this).toggleClass('animate-in', top <= trigger).toggleClass('animate-out', top > trigger);
    });
  }

  $('[id*=views-exposed-form-buscador] #edit-search-api-fulltext').focus(function () {
    $(this).removeAttr('value');
  });

  // Webform confirmation modal
  Drupal.webform = Drupal.webform || {};
  Drupal.webform.confirmationModal = Drupal.webform.confirmationModal || {};
  Drupal.webform.confirmationModal.options = {
    minWidth: 0,
    width: 'auto',
    dialogClass: 'webform-confirmation-modal hs-modal-enhanced',
    open: function () {
      var $dialog = $(this).closest('.ui-dialog');
      if ($dialog.length && !$dialog.data('hs-enhanced')) {
        enhanceWebformModal($dialog);
      }
    }
  };

  function enhanceWebformModal($dialog) {
    if ($dialog.data('hs-enhanced')) return;
    $dialog.data('hs-enhanced', true);

    var autoCloseTime = 7000;
    var autoCloseTimer, remainingTime = autoCloseTime, enterTime;

    $dialog.addClass('hs-modal-enhanced').css({
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      width: '90%', 'max-width': '460px', 'min-width': 0,
      height: 'fit-content', margin: 'auto', border: 'none',
      'border-radius': '20px', background: '#fff',
      'box-shadow': '0 32px 64px -12px rgba(0,0,0,.2), 0 0 0 1px rgba(0,0,0,.04)',
      padding: 0, overflow: 'hidden', 'z-index': 10002,
      animation: 'webformModalFadeIn .45s cubic-bezier(.16,1,.3,1) forwards'
    });

    $dialog.find('.ui-dialog-titlebar, .webform-confirmation__back, .ui-dialog-buttonpane').hide();

    $dialog.find('.ui-dialog-content').css({
      width: 'auto', 'min-height': 0, height: 'auto',
      padding: '52px 40px 36px', 'text-align': 'center',
      overflow: 'visible', 'font-family': 'inherit'
    });

    var $overlay = $('.ui-widget-overlay').css({
      background: 'rgba(0,0,0,.5)', opacity: 1,
      'backdrop-filter': 'blur(4px)', '-webkit-backdrop-filter': 'blur(4px)',
      cursor: 'pointer'
    });

    var lang = (document.documentElement.lang || 'es').substring(0, 2);
    var closeLabels = { es: 'Cerrar', en: 'Close', fr: 'Fermer', eu: 'Itxi' };
    var closeText = closeLabels[lang] || closeLabels.es;

    if (!$dialog.find('.webform-modal-close-btn').length) {
      $('<button type="button" class="webform-modal-close-btn">' + closeText + '</button>')
        .appendTo($dialog)
        .on('click', closeModal);
    }

    $overlay.on('click.hsModal', closeModal);
    $(document).on('keydown.hsModal', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) { e.preventDefault(); closeModal(); }
    });

    autoCloseTimer = setTimeout(closeModal, autoCloseTime);

    $dialog.on('mouseenter.hsModal', function () {
      clearTimeout(autoCloseTimer);
      enterTime = Date.now();
    }).on('mouseleave.hsModal', function () {
      remainingTime = Math.max(remainingTime - (Date.now() - (enterTime || Date.now())), 3000);
      autoCloseTimer = setTimeout(closeModal, remainingTime);
    });

    function closeModal() {
      if ($dialog.data('hs-closing')) return;
      $dialog.data('hs-closing', true);
      clearTimeout(autoCloseTimer);
      $(document).off('keydown.hsModal');
      $overlay.off('click.hsModal');
      $dialog.off('.hsModal');

      $dialog.css('animation', 'webformModalFadeOut .3s ease-in forwards');
      $overlay.css({ transition: 'opacity .3s ease', opacity: 0 });

      setTimeout(function () {
        try { $dialog.find('.ui-dialog-content').dialog('close'); } catch (e) {}
        $dialog.remove();
        $overlay.remove();
      }, 320);
    }
  }

})(jQuery, Drupal);